import PoaButton from './poa-button';

export default PoaButton;
